(function () {
    'use strict';

    angular
        .module('procedureModule')
        .controller('ProcedureModalController', Controller);

    Controller.$inject = ['$scope', 'searchService'];

    function Controller($scope, searchService) {
        $scope.ctxSelection = {
            searchTerm: null
        };

        $scope.searchProcedure = function (searchTerm) {
            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableProcedures = [];
                return;
            }
            searchService
                .searchProcedure(searchTerm, true)
                .then(function (foundProcedures) {
                    if (foundProcedures && foundProcedures.Results) {
                        $scope.availableProcedures = foundProcedures.Results;
                    } else {
                        $scope.availableProcedures = [];
                    }
                });
        };
    }
})();